export enum StackingLevel {
  LOW = 10,
  MED = 20,
  HIGH = 30,
}

export const contentZIndex = 1;

export const NavBarZIndex = 1100;
export const mobilePopperZIndex = NavBarZIndex + StackingLevel.LOW;
// Make next step lower than modals
export const nextStepZIndex = NavBarZIndex + StackingLevel.HIGH;

export const explorerAgentZIndex = 1200;
export const popperZIndex = explorerAgentZIndex + StackingLevel.HIGH;

export const drawerZIndex = 1200;

export const menuZIndex = 1400;
export const bottomNavigationZIndex = explorerAgentZIndex + StackingLevel.HIGH;

// Modals are always 1300, and mui doesn't let altering it
// therefore we have to make everything lower than that
export const shareCaseModalZIndex = 1300;
//Except tooltip
export const toolTipZIndex = shareCaseModalZIndex + StackingLevel.HIGH;

export const ddListZIndex = 1700;
